<template>
  <div v-cloak>
    <div>

<div v-if="headerData">
      <div id="poheader" v-if="!isBusy">

        <b-container class="p-0">
          <div class="border p-2">
          <b-row>
            <b-col>
              <div><b>PO# {{ headerData.pO_Number }}</b> </div>
              <div><b>Vendor: </b> {{ headerData.vendorId }} {{ headerData.vendor }}</div>
            </b-col>
            <b-col>
              <div><b>Ref: </b> {{headerData.reference}} <b>PO Date: </b>  {{ headerData.pO_Date }} </div>
              <div><b> Buyer: </b> {{ headerData.buyer }}</div>
            </b-col>            

          </b-row>

         </div>
        </b-container>
       
      </div>
      
 </div>

      <div id="poitems">
        <b-table
          small
          striped
          outlined
          head-variant="light"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="isBusy"
          :items="itemsData"
          :fields="tableFields"
        >
        <template v-slot:cell(item)="data">
            <div> {{parseInt(data.value)}} </div>
        </template>
        <template v-slot:cell(outstanding)="data">
          <div v-if="!data.item.outstanding == 0"> {{data.item.outstanding}} </div>
        </template>
        <template v-slot:cell(received)="data">
          <div v-if="!data.item.received == 0"> {{data.item.received}} </div>
        </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner></b-spinner>
          <div>
              <strong>Loading...</strong>
            </div>
          </div>
        </b-table>
      </div>
    </div>

    <b-pagination
      v-show="totalRows>perPage"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="poitems"
      hide-ellipsis
    ></b-pagination>

    <div v-if="errored">
      <p class="text-danger">An error occurred loading data.</p>
      <p>{{ error }}</p>
      <p>
        <b-button type="button" @click="reload">Reload</b-button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PurchaseOrder",
  props: {},
  components: {},

  data: function() {
    return {
      state: this.$store.state,
      projectId: this.$route.params.id,
      project: [],
      poId: this.$route.params.poId,
      perPage: 24,
      currentPage: 1,
      totalRows: 0,
      isBusy: true,
      data: null,
      modules: [],
      headerData: null,
      itemsData: null,
      loading: true,
      loaded: false,
      errored: false,
      error: "",
     
      tableFields: [
        {
          key: "item",
          sortable: true,
          label: "Item"
        },
        {
          key: "description",
          sortable: true,
          label: "Description"
        },
        {
          key: "quantity",
          sortable: true,
          label: "Qty",
          class: "text-right"
        },
        {
          key: "unit",
          sortable: false,
          label: " "
        },
        {
          key: "price",
          sortable: false,
          label: "Price ",
          class: "text-right"
        },        
                {
          key: "received",
          sortable: true,
          label: "Rec'd",
          class: "text-right"
        },
                {
          key: "outstanding",
          sortable: false,
          label: "O/s",
          class: "text-right"
        }
      ]
    };
  },

  computed: {},

  methods: {
    reload() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
    },

    fetchData() {
      this.$auth.acquireToken().then(token => {
        Promise.all([
           this.$http.get(
            "api/Project/"  + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          ),
          this.$http.get(
            "api/PurchaseOrderHeader/"  + this.projectId + "/" + this.poId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          ),
          this.$http.get(
            "api/PurchaseOrderItems/" + this.projectId + "/" + this.poId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          )
        ])
          .then(results => {
            if (results[0].status == 204){
              this.errored = true;
              this.error = "Project " + this.projectId + ": Not found/No user access ";
            }
          else{
            this.modules = results[0].data.modules;
            this.project = results[0].data.project;
            this.$store.setItem("project",this.project.projectId + " " + this.project.description);
            this.$store.setItem("projectId", this.project.projectId);

            //check for poprice flag
            if (!this.modules.includes('poprice')){
                this.tableFields.splice(4,1);  //remove price field
            }
            
            //check for module assignment
            if (!this.modules.includes('poviewer')){
                this.errored = true;
                this.loaded = false;
                this.error = this.project.projectId + " PO Viewer access not assigned to user.";
            }
            else{
            this.headerData = results[1].data[0];
            this.itemsData = results[2].data;
            this.totalRows = this.itemsData.length;
            }
          }

          })
          .catch(error => {
            this.errored = true;
            this.loaded = false;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

    setBreadcrumb(){
      this.$store.setItem("breadcrumbs", [
      {
        text: this.projectId,
        to: {name: "Project", params: this.projectId}
      },
      {
        text: "Purchase Orders",
         to: {name: "PurchaseOrders", params: {id: this.projectId}}
      },
      {
        text: this.poId,
       
      }
    ]);
    }
  },

  mounted: function() {
      this.isBusy = true;
      this.fetchData();
  },

   activated: function() {
      this.setBreadcrumb();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#poheader {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
}

#poitems {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  padding-top: 10px;
}

@media (max-width: 400px) {
    #poitems {
    font-size:.75rem;
    }
}

.col-centered {
  float: none;
  margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
  color: darkred;
}

</style>